module.exports = __webpack_public_path__ + "img/blue-Group 668.f6614f25.svg";